












































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DataGrid } from '@questelservices/common-vue';
import dxDataGrid from 'devextreme/ui/data_grid';
import { DxProgressBar, DxButton } from 'devextreme-vue';
import DxDataGrid, {
  DxGrouping,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  DxSorting,
  DxRemoteOperations,
  DxColumn
} from 'devextreme-vue/data-grid';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { MatterWorkTypeEnum } from '../../models/matter-work/MatterWorkTypeEnum';
import CommonModule, { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import dialog from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { getModule } from 'vuex-module-decorators';
import { BatchService } from '@/service/BatchService';
import { AuditingService } from '@/service/AuditingService';
import { BatchEventTypeDateDto } from '@/models/batch/BatchEventTypeDateDto';
import { BatchEventTypeEnum, BatchEventDateTypeEnum } from '@/models/batch/BatchEventTypeEnum';

@Component({
  components: {
    DataGrid,
    DxProgressBar,
    DxColumn,
    DxRemoteOperations,
    DxGrouping,
    DxSummary,
    DxGroupItem,
    DxSortByGroupSummaryInfo,
    DxSorting,
    DxButton,
    DxLoadPanel
  }
})
export default class ClaimedWork extends Vue {
  public $refs: Vue['$refs'] & {
    claimedWorkDataGrid?: DataGrid;
  } = {};

  @Prop()
  title!: string;

  @Prop()
  matterWorkType!: MatterWorkTypeEnum;  

  claimedWorkUrl: string = `/api/activityplanner/claimed/${this.matterWorkType}`;
  private dxDataGrid?: dxDataGrid;
  private firstLoad: boolean = true;    
  private client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');
  private commonState = getModule(CommonModule, this.$store);
  private auditingService: AuditingService;
  private batchService: BatchService;
  private releaseInProgress: boolean = false;

  constructor() {
    super();    
    this.batchService = new BatchService();
    this.auditingService = new AuditingService();
  }

  mounted() {
    if (this.$refs.claimedWorkDataGrid) {
      let dataGridRef = this.$refs.claimedWorkDataGrid as any;
      this.dxDataGrid = dataGridRef.$refs.dxDataGrid.instance as dxDataGrid;
    }
  }

  refreshDataGrid() {
    if (this.$refs.claimedWorkDataGrid) {
      (this.$refs.claimedWorkDataGrid as any).refreshDataGrid();
    }
  }

  expandFirstGroup() {
    if (this.dxDataGrid) {
      // Expand first group
      this.dxDataGrid.expandRow(this.dxDataGrid.getKeyByRowIndex(0));
    }
  }

  onRowPrepared(e: any) {
    if (e.rowType === 'data' && e.data.MatterWorkId) {
      let location = this.getClaimedWorkLink(e);
      e.rowElement.addEventListener('auxclick', (event: any) => {
        if (event.which === 2 && location != null) {
          event.preventDefault();
          event.stopPropagation();
          window.open(location.href, '_blank');
        }
      });
    }
  }

  private getClaimedWorkLink(e: any) {
    if (e.data.MatterWorkId) {
      switch (this.matterWorkType) {
        case MatterWorkTypeEnum.Coding:
          return this.$router.resolve(`/phase-assignment/${e.data.MatterWorkId}`);
        case MatterWorkTypeEnum.Auditing:
          return this.$router.resolve(`/auditing/${e.data.MatterWorkId}?cases=${e.data.ClaimedCasesCount}`);
        default:
          return;
      }
    }
  }

  onRowClick(e: any) {
    if (e.rowType === 'data' && e.data.MatterWorkId) {
      switch (this.matterWorkType) {
        case MatterWorkTypeEnum.Coding:
          this.$router.push(`/phase-assignment/${e.data.MatterWorkId}`);         
          break;
        case MatterWorkTypeEnum.Auditing:
          this.$router.push(`/auditing/${e.data.MatterWorkId}?cases=${e.data.ClaimedCasesCount}`);
          break;
        default:
          break;
      }
    }
  }

  onContentReady(e: any) {
    if (this.firstLoad) {
      this.expandFirstGroup();
      this.firstLoad = false;
    }
  }

  async confirmReleaseClaim(data: any) {
    let currentUserId = this.commonState.jwtData.Id;
    
    let ownerString = currentUserId === data.ClaimedById
      ? 'your'
      : `${data.ClaimedBy}'s`;
    
    let casesString = data.ClaimedCasesCount === 1 ? "case" : "cases";
    let message = `Are you sure you want to release ${ownerString} claim of ${data.ClaimedCasesCount} ${casesString} for ${data.ClientName}?`;
    let releaseConfirmed = await dialog.confirm(message, 'Confirm');

    if (releaseConfirmed) {
      notify('Releasing claimed work...', 'info', 4000);
      this.releaseInProgress = true;
      await this.client.sendRequest(HttpMethodEnum.Post, `/api/matterworks/${data.MatterWorkId}/release-matters`)
        .then(result => {
          notify('Claimed work successfully released', 'success', 4000);
        })
        .catch(reason => {
          notify('An error occurred releasing the claimed work', 'error', 4000);
        })
        .finally(() => {
          this.releaseInProgress = false;
        });

      if (this.matterWorkType === MatterWorkTypeEnum.Auditing) {
        const auditCompleted = await this.auditingService.auditCompleted(data.ClientId);
        if (auditCompleted.Value) {
          const dto: BatchEventTypeDateDto = {
            BatchEventType: BatchEventTypeEnum.ReportAvailable,
            BatchEventDateType: BatchEventDateTypeEnum.ScheduledDate
          };
          
          try {            
            const date = await this.batchService.getBatchEventTypeDate(data.ClientId, dto);
            if (date.Data.reportAvailableDate != null) {
              const formattedDate = (this.$options.filters as any).moment(date, "MM-DD-YYYY");
              const sendReportingMsg = `Are these ready to be reported on? These will be automatically sent on ${formattedDate}.`;
              const okayToSendReporting = await dialog.confirm(sendReportingMsg, 'Confirm');
              if (okayToSendReporting) {
                await this.batchService.setReadyForReporting(data.ClientId);
              }
            }
            else {              
              notify('Report Available Batch Event not found.','error', 10000);
              return;
            }
          } catch (error) {            
            notify('Error occured while Releasing Matters.','error', 10000);
            return;
          }          
        }
      }

      this.$emit("claimed-work-released");
    }

    return false;
  } 

}
